import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { EvseOperationType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOperationType',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  type: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl, t } = useI18nTl('Operation')



const statusLabel = computed(() => {
  switch (props.type) {
    case EvseOperationType.EOT_HOME:
      return tl('orderTypeHome')
    case EvseOperationType.EOT_OPERATOR:
      return tl('orderTypeOperator')
  }
  return t('Base.unknown')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})